import { action } from '@ember/object';
import { scheduleOnce } from '@ember/runloop';

import $ from 'jquery';

import type { Args } from 'webapp/components/form/custom-ace-editor';
import FormCustomAceEditorComponent from 'webapp/components/form/custom-ace-editor';

export default class QueryBuilderFieldCustomCodeComponent extends FormCustomAceEditorComponent<Args> {
	private targets!: JQuery;

	@action
	resizeEditor() {
		const editor = this.editor;
		if (editor) {
			scheduleOnce('afterRender', editor, editor.resize);
		}
	}

	@action
	override setupView(node: HTMLElement) {
		super.setupView(node);

		const el = $(node);
		const targets = el.closest('.panel').add($(node).closest('.item'));
		this.targets = targets;

		targets.on('resize', this.resizeEditor);
	}

	@action
	override teardownView() {
		this.targets.off('resize', this.resizeEditor);
	}
}
